<template>
  <div>
    <v-layout wrap pt-10>
      <v-flex xs12>
        <v-layout wrap justify-center py-10>
          <v-flex xs12 text-center>
            <span
              style="color: #000000; font-family: poppinsbold; font-size: 25px"
              >What our Customers are saying</span
            >
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex xs11 sm10>
            <OwlCarousel
              :nav="false"
              :dots="false"
              :loop="true"
              :autoplay="true"
              :autoplayTimeout="3000"
              :responsive="owlResponsive"
            >
              <template xs12 sm10 v-for="(item, i) in items">
                <v-layout wrap justify-center pa-2 :key="i">
                  <v-flex xs12 sm12 md12>
                    <v-card rounded="xl">
                      <v-layout wrap justify-center pa-5>
                        <v-flex xs3 sm2>
                          <v-layout wrap>
                            <v-flex xs12 pb-5 pt-10>
                              <!-- <v-img :src="item.image"></v-img> -->
                              <v-avatar size="50px" color="grey">
                                <v-icon dark large> mdi-account-circle </v-icon>
                              </v-avatar>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs9 sm10>
                          <v-layout wrap>
                            <v-flex xs12 text-left>
                              <v-rating
                                color="#F28F34"
                                background-color="#F28F34"
                                readonly
                                v-model="item.rating"
                                half-increments
                                hover
                                small
                              ></v-rating>
                            </v-flex>
                            <v-flex xs12 text-left py-3>
                              <!-- <span
                                v-if="!item.showFullText"
                                style="
                                  font-family: opensansregular;
                                  color: #000000;
                                "
                              >
                                {{ truncateText(item.title, 100) }}
                              </span> -->
                              <span
                                style="
                                  font-family: poppinsregular;
                                  color: #000000;
                                "
                              >
                                {{ item.title }}
                              </span>
                            </v-flex>
                            <!-- <v-flex
                              xs12
                              text-right
                              v-if="item.title.length > 100"
                            >
                              <v-btn text tile depressed @click="toggleText(i)">
                                <span
                                  style="
                                    font-family: opensansbold;
                                    font-size: 13px;
                                    text-transform: none;
                                    color: #00000;
                                  "
                                  >{{
                                    item.showFullText
                                      ? "Read Less"
                                      : "Read More"
                                  }}</span
                                >
                              </v-btn>
                            </v-flex> -->
                            <!-- <v-flex xs12 text-left v-if="item.showFullText">
                              <span
                                style="
                                  font-family: opensansregular;
                                  color: #000000;
                                "
                                >{{ item.title }}</span
                              >
                            </v-flex> -->
                            <v-flex xs12 pb-5 text-left>
                              <span
                                style="
                                  font-family: opensansbold;
                                  color: #000000;
                                "
                                >{{ item.name }}</span
                              >
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </template>
            </OwlCarousel>
          </v-flex>
        </v-layout>

        <v-layout wrap>
          <v-flex xs12>
            <v-img src="./../../assets/images/feedback.png">
              <template v-slot:placeholder>
                <ImageLoader />
              </template>
            </v-img>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["ratings"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,

      items: [
        {
          title:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna",
          image: require("./../../assets/images/fb1.png"),
          name: "Kartik Bansal",
          rating: 5,
          place: "Kota, Rajasthan",
        },
        {
          title:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna",
          image: require("./../../assets/images/fb2.png"),
          name: "Anil Dvivedi",
          rating: 4,
          place: "New Delhi",
        },
        {
          title:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna",
          image: require("./../../assets/images/fb3.png"),
          name: "Srijan Sirasikar",
          rating: 4,
          place: "Bhadrak",
        },
      ],
      owlResponsive: {
        0: { items: 1, nav: false },
        600: { items: 1, nav: false },
        960: { items: 2, nav: false },
        1264: { items: 2, nav: false },
        1920: { items: 2, nav: false },
      },
    };
  },
  methods: {
    truncateText(text, maxLength) {
      return text.length > maxLength
        ? text.substring(0, maxLength) + "..."
        : text;
    },
    toggleText(index) {
      this.$set(this.items, index, {
        ...this.items[index],
        showFullText: !this.items[index].showFullText,
      });
    },
  },
};
</script>